<template>
    <span v-if="validator.$error" class="text-danger m-l-sm">
        <template v-if="!validator.required && validator.$params.hasOwnProperty('required')">This field is required.</template>
        <template v-else-if="!validator.minLength && validator.$params.hasOwnProperty('minLength')">Must have at least {{validator.$params.minLength.min}} characters.</template>
        <template v-else-if="!validator.maxLength && validator.$params.hasOwnProperty('maxLength')">Cannot have more than {{validator.$params.maxLength.max}} characters.</template>
        <template v-else-if="!validator.notSameAs && validator.$params.hasOwnProperty('notSameAs')">Cannot match {{ validator.$params.notSameAs.$sub[0].eq }}</template>
        <template v-else-if="!validator.sameAsPassword && validator.$params.hasOwnProperty('sameAsPassword')">Passwords must match.</template>
        <template v-else-if="!validator.isUnique && validator.$params.hasOwnProperty('isUnique')">This is already in use.</template>
    </span>
</template>

<script>
    export default {
        props: {
            validator: {
                type: Object,
                required: true
            }
        }
    }
</script>